import { Stack } from '@bedrock-layout/stack';
import styled from 'styled-components';

export const RestInCISheetWrapper = styled(Stack)`
  padding: 1.2rem;
`;
